import { CdnService } from '@/common/services/cdn/cdn.service';
import { PrivacyPolicyResponse } from '@/core/domain/privacy-policy/models/privacy-policy-response.model';
import { PrivacyPolicyRepository } from '@/core/domain/privacy-policy/repositories/privacy-policy.respository';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PrivacyPolicyImplRepository extends PrivacyPolicyRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        super();
    }

    override getPrivacyPolicy(): Observable<PrivacyPolicyResponse> {
        return this.http.get<PrivacyPolicyResponse>(
            CdnService.url(
                'privacy-policy-json/' +
                    this.getLanguageUseCase.execute().language +
                    '.json',
            ),
        );
    }
}
